<script lang="ts">
  // components
  import ResultsTable from './ResultsTable.svelte';

  // utils
  import {
    isMeasure,
    numberOfWinners,
    orderedChoices,
  } from '../utils/race-helpers.js';

  // types
  import type { Readable } from 'svelte/store';
  import type { Race, CrosswalkImage } from '../types';

  export let feed: Readable<Race | undefined>;
  export let face = false;
  export let crosswalk: Record<string, CrosswalkImage> = {};

  $: race = $feed;
</script>

<!-- race is undefined if its ID isn't in the feed -->
{#if race}
  <ResultsTable
    {face}
    {crosswalk}
    raceId={race.id}
    candidates={orderedChoices(race)}
    totalVotes={race.attributes.totalVotes}
    isBallotMeasure={isMeasure(race)}
    eevp={race.attributes.eevp ?? null}
    numOfwinners={numberOfWinners(race)} />
{/if}
